<template>
    <div class="create-box">
      <div class="create-box-item" @click.stop="goCreate">
        <div class="top">
          <h3>发布动态</h3>
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/go-red.svg" />
        </div>
        <span>晒晒你的头条/趣闻</span>
      </div>
      <div class="create-box-item" @click.stop="goSummoningOrder">
        <div class="top">
          <h3>发布召集令</h3>
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/go-green.svg" />
        </div>
        <span>约上身边的小伙伴</span>
      </div>
    </div>
</template>
<script>
export default {
  methods: {
    goCreate () {
      this.$router.push('/exerland/create')
    },
    goSummoningOrder () {
      this.$router.push('/exerland/createSummoningOrder')
    }
  }
}
</script>
<style lang="scss" scoped>

  .create-box {
    width: 100%;
    padding: 0 16px;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    .create-box-item {
      box-sizing: border-box;
      width: 164px;
      height: 76px;
      margin-bottom: 74px;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      padding: 17px 19px;
      .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 25px;
        }
      }
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(136, 136, 136, 1);
        line-height: 17px;
      }
    }
  }
</style>
